export const meta = {
  title: '隐私政策 | PhotoCraft ArtCraft AI',
  description:
    'PhotoCraft ArtCraft AI（photocraftartcraft.com）如何处理访客、账户和统计信息。',
  updated_at: '2026-10-22',
};

## 关于我们

PhotoCraft ArtCraft AI（下称"我们"）运营 photocraftartcraft.com，这是一个独立的 PhotoCraft 与 VectorCraft 指南站。它们是 ArtCraft 项目推出的开源图像编辑器和矢量编辑器。我们与 ArtCraft、Storyteller、Adobe 均无关联。联系方式：[support@photocraftartcraft.com](mailto:support@photocraftartcraft.com)。

## 下载由 GitHub 提供

本站不托管安装包，所有下载按钮都指向 GitHub 上 PhotoCraft 或 VectorCraft 的官方 Releases。点击下载时，你的浏览器会直接连接 GitHub，这次请求适用 [GitHub 隐私声明](https://docs.github.com/en/site-policy/privacy-policies/github-general-privacy-statement)。我们看不到、也不会保存你下载的文件。

## 在线编辑器在你的浏览器中运行

PhotoCraft 在线编辑器（photocraftartcraft.com/editor）和 VectorCraft 在线版（app.photocraftartcraft.com）是官方开源网页版，由本站通过 Cloudflare 提供。它们完全在你的浏览器中运行：你打开、创建或保存的图片和图稿都不会上传给我们，保存时文件会直接下载到你自己的设备上。编辑器的偏好设置保存在浏览器的本地存储中。

## 我们处理的信息

- **基础请求数据。** 托管服务商（Cloudflare）会处理 IP 地址、浏览器类型和你访问的页面，用于提供网站服务和安全防护。
- **访问统计。** 如果开启了统计，我们会用注重隐私的统计工具了解哪些页面被访问、访客从哪里来，仅用于改进网站。
- **账户数据。** 如果你主动注册账户，我们会保存你的邮箱、昵称和登录信息，密码以哈希形式存储。
- **沟通记录。** 你发邮件或提交工单时，我们会保留对话记录以便回复。

## Cookie

我们使用必要的 Cookie 来记住语言、主题和登录状态。开启统计工具时，这些工具可能会设置自己的 Cookie。

## 信息共享

我们不出售个人信息，只会与维持网站运行的服务商（托管、邮件发送、统计）共享，或在法律要求时提供。

## 保存期限与你的权利

账户存续期间我们会保存账户数据，你提出删除后即删除。如需查阅、更正或删除你的信息，请发邮件至 [support@photocraftartcraft.com](mailto:support@photocraftartcraft.com)。

## 政策变更

我们可能会更新本政策，页面顶部的日期表示最后更新时间。
